export interface LocationDialogOutput {
    result: 'success' | 'failed';
    reason?: LocationDialogFailureReason;
}

export enum LocationDialogFailureReason {
    NO_COORDINATE,
    NO_FIELD_DEFINITION
}
